import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Form,
    FormGroup,
    Label,
    Input
} from 'reactstrap';
import { addDocument as onAddDocument } from "../../slices/thunks";

import  DOCUMENT_TYPES from "./Types"

function DocumentUploadModal({
                                 contract,
                                 isOpen,
                                 toggle,
                                 onUploadSuccess
                             }) {
    const dispatch = useDispatch();
    const [file, setFile] = useState(null);
    const [documentType, setDocumentType] = useState('CONTRACT');
    const [description, setDescription] = useState('');
    const [uploading, setUploading] = useState(false);

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        setFile(selectedFile || null);
    };

    const handleUpload = async () => {
        if (!file) {
            alert('Please select a file');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);
        formData.append('contract', contract.id);
        formData.append('document_type', documentType);

        if (description.trim()) {
            formData.append('description', description);
        }

        setUploading(true);
        try {
            await dispatch(onAddDocument(formData)).unwrap();

            // Reset form and close modal
            setFile(null);
            setDescription('');
            toggle();

            onUploadSuccess?.();
        } catch (error) {
            console.error('Document upload error:', error);
            alert(error.message || 'Failed to upload document');
        } finally {
            setUploading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Upload Document</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="documentFile">File</Label>
                        <Input
                            type="file"
                            name="file"
                            id="documentFile"
                            onChange={handleFileChange}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="documentType">Document Type</Label>
                        <Input
                            type="select"
                            name="documentType"
                            id="documentType"
                            value={documentType}
                            onChange={(e) => setDocumentType(e.target.value)}
                        >
                            {DOCUMENT_TYPES.map((type) => (
                                <option key={type.value} value={type.value}>
                                    {type.label}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="documentDescription">Description</Label>
                        <Input
                            type="textarea"
                            name="description"
                            id="documentDescription"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Optional document description"
                        />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    Cancel
                </Button>
                <Button
                    color="primary"
                    onClick={handleUpload}
                    disabled={!file || uploading}
                >
                    {uploading ? 'Uploading...' : 'Upload'}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default DocumentUploadModal;
